import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'

import AddressRow from 'src/components/layout/AddressRow'
import Hours from './BusinessHours'
import { Location } from 'src/types/schema/graphql'
import Map from './Map'
import { Socials } from 'src/features/brewer/components'
import classNames from 'classnames'
import { useStickyNav } from '../../state/useStickyNav'
import Link from 'next/link'
import { mapStore } from 'src/features/Map/state/mapStore'

// import Socials from './Socials'

interface IDetails {
    location: Location
}

const Details: React.FC<IDetails> = ({ location }) => {
    const { space } = useStickyNav()
    const { geo } = location.address
    const setOnLoadCenterCoords = mapStore((state) => state.setOnLoadCenterCoords)
    const handleMapClick = () => setOnLoadCenterCoords(location.address.geo)
    const strippedWebsite = location?.brand?.website?.replace(/https?:\/\//g, '')

    return (
        <div className='space-y-6' id='details'>
            <UI.Heading text='Details' size='h4' type='h2' customClasses='text-xl lg:text-2xl' />
            <UI.Card>
                <div className='w-full space-y-6'>
                    {location.hours && <Hours location={location} />}
                    {geo && (
                        <Link href='/map'>
                            <a onClick={handleMapClick}>
                                <Map geo={geo} />
                            </a>
                        </Link>
                    )}
                    <div className={classNames('space-y-6', space)} id='address'>
                        <UI.Heading size='h6'>{location.title}</UI.Heading>
                        <AddressRow address={location.address} />
                    </div>

                    <div className='h-px w-full bg-gray-100' />
                    <div className=' space-y-6'>
                        {location?.links && (
                            <a
                                title={`View ${location.title} website in a new window`}
                                href={`//${strippedWebsite}`}
                                rel='noreferrer'
                                target='_blank'
                            >
                                <UI.Button
                                    theme='link'
                                    customClasses='p-0 items-center  flex flex-row'
                                >
                                    <UI.Icon slug='HeroIcons.Link' size='md mr-2' />
                                    <p>{location.brand.website}</p>
                                </UI.Button>
                            </a>
                        )}
                        {location.contact?.phone && (
                            <div>
                                <a
                                    href={`tel:${location.contact.phone}`}
                                    target='_blank'
                                    rel='noreferrer'
                                    title={`Call the ${location.title} location.`}
                                >
                                    <UI.Button
                                        theme='link'
                                        customClasses='p-0 items-center  flex flex-row'
                                    >
                                        <UI.Icon slug='HeroIconsSolid.Phone' size='md mr-2' />
                                        <p>{location.contact.phone}</p>
                                    </UI.Button>
                                </a>
                            </div>
                        )}
                        {location.brand.socialMedia?.length && (
                            <div>
                                <Socials socials={location.brand.socialMedia} />
                            </div>
                        )}
                    </div>
                </div>
            </UI.Card>
        </div>
    )
}

export default Details
